import { connectRouter } from 'connected-react-router';
import layout from 'src/modules/layout/layoutReducers';
import auth from 'src/modules/auth/authReducers';
import tenant from 'src/modules/tenant/tenantReducers';
import plan from 'src/modules/plan/planReducers';
import user from 'src/modules/user/userReducers';
import auditLog from 'src/modules/auditLog/auditLogReducers';
import settings from 'src/modules/settings/settingsReducers';
import event from 'src/modules/event/eventReducers';
import tag from 'src/modules/tag/tagReducers';
import category from 'src/modules/category/categoryReducers';
import eventClass from 'src/modules/eventClass/eventClassReducers';
import eventTimeZone from 'src/modules/eventTimeZone/eventTimeZoneReducers';
import country from 'src/modules/country/countryReducers';
import place from 'src/modules/place/placeReducers';
import eventSchedule from 'src/modules/eventSchedule/eventScheduleReducers';
import contact from 'src/modules/contact/contactReducers';
import position from 'src/modules/position/positionReducers';
import countryState from 'src/modules/countryState/countryStateReducers';
import { combineReducers } from 'redux';

export default (history) =>
  combineReducers({
    router: connectRouter(history),
    layout,
    auth,
    tenant,
    plan,
    user,
    auditLog,
    settings,
    event,
    tag,
    category,
    eventClass,
    eventTimeZone,
    country,
    place,
    eventSchedule,
    contact,
    position,
    countryState
  });
